// import React from 'react';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
// import React, { useState, useEffect, useRef } from 'react'
import React, { ReactElement, useEffect, useState } from "react"
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { fade, lighten, makeStyles, useTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import VisibilityIcon from '@material-ui/icons/Visibility';

import Tooltip from '@material-ui/core/Tooltip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { Box, Button, TextField } from '@material-ui/core';
import Popover from '@material-ui/core/Popover';
import axios from 'axios';
// Test123

const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },

}));

function TablePaginationActions(props: any) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event: any) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event: any) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event: any) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event: any) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};
function descendingComparator(a: any, b: any, orderBy: any) {
    // if (b[orderBy] < a[orderBy]) {
    //     return -1;
    // }
    // if (b[orderBy] > a[orderBy]) {
    //     return 1;
    // }
    return 0;
}

function getComparator(order: any, orderBy: any) {
    return order === 'desc'
        ? (a: any, b: any) => descendingComparator(a, b, orderBy)
        : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

function stableSort(array: any, comparator: any) {


    const stabilizedThis = array
        .map((el: any, index: any) => [el, index]);
    stabilizedThis.sort((a: any, b: any) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el: any) => el[0]);
}

const headCells = [

    // { id: 'dealerId', numeric: true, disablePadding: false, label: 'DealerId' },
    { id: 'dmsDealerId', numeric: true, disablePadding: false, label: 'DmsDealerId' },
    { id: 'name', numeric: false, disablePadding: false, label: 'Dealer' },
    { id: 'dmsName', numeric: false, disablePadding: false, label: 'Type' },
    { id: 'orderId', numeric: true, disablePadding: false, label: 'OrderId' },
    { id: 'orderDate', numeric: false, disablePadding: false, label: 'OrderDate' },
    { id: 'dmsOrderId', numeric: true, disablePadding: false, label: 'DMSOrderId' },
    { id: 'invoiceNumber', numeric: true, disablePadding: false, label: 'BillNumber' },
    { id: 'dmsOrderDate', numeric: false, disablePadding: false, label: 'DMSOrderDate' },
    { id: 'dmsError', numeric: false, disablePadding: false, label: 'Error' },
    { id: 'syncNow', numeric: false, disablePadding: false, label: 'Sync' },
    { id: 'isActive', numeric: false, disablePadding: false, label: 'Active' },
    { id: '', numeric: false, disablePadding: false, label: '' },
    // { id: 'name', numeric: false, disablePadding: false, label: 'Dealer Name' },
    // { id: 'dmsName', numeric: false, disablePadding: false, label: 'Type' },
    // { id: 'isHosted', numeric: false, disablePadding: false, label: 'Hosted' },
    // { id: 'invoice', numeric: false, disablePadding: false, label: 'Invoice' },
    // { id: 'customer', numeric: false, disablePadding: false, label: 'Customer' },
    // { id: 'inventoryPart', numeric: false, disablePadding: false, label: 'Part' },
    // { id: 'inventoryWG', numeric: false, disablePadding: false, label: 'Wholegood' },
    // { id: 'user', numeric: false, disablePadding: false, label: 'User' },
    // { id: 'dealer', numeric: false, disablePadding: false, label: 'Dealer' },
];

function EnhancedTableHead(props: any) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = (property: any) => (event: any) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow style={{ backgroundColor: "#F4F6F7", fontWeight: "bold" }}>
                {/* <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
          />
        </TableCell> */}
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    title: {
        flex: '1 1 100%',
    },
}));

const EnhancedTableToolbar = (props: any) => {
    const classes = useToolbarStyles();
    const { numSelected } = props;

    return (
        <div></div>
        // <Toolbar
        //   className={clsx(classes.root, {
        //     [classes.highlight]: numSelected > 0,
        //   })}
        // >
        //   {numSelected > 0 ? (
        //     <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
        //       {numSelected} selected
        //     </Typography>
        //   ) : (
        //     <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
        //       Nutrition
        //     </Typography>
        //   )}

        //   {numSelected > 0 ? (
        //     <Tooltip title="Delete">
        //       <IconButton aria-label="delete">
        //         {/* <DeleteIcon /> */}
        //       </IconButton>
        //     </Tooltip>
        //   ) : (
        //     <Tooltip title="Filter list">
        //       <IconButton aria-label="filter list">
        //         {/* <FilterListIcon /> */}
        //       </IconButton>
        //     </Tooltip>
        //   )}
        // </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    notFeeding: {
        // backgroundColor:"red",
        // color:"white"
        color: "red"
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: "white",
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        color: "white",
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        fontWeight: "bolder",
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

export default function ExternalOrders({ search, DefaultSearch }: { search: string, DefaultSearch: (value: string) => void; }) {
    // export default function ExternalOrders() {
    const classes = useStyles();
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('orderId');
    const [selected, setSelected] = React.useState([] as any);
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(true);
    const [rowsPerPage, setRowsPerPage] = React.useState(15);
    const [rowsCount, SetRowsCount] = React.useState(0);
    const [data, SetData] = useState([] as any);
    const [dataResponse, SetDataResponse] = useState([] as any);
    const [searchdata, SetSearchdata] = useState('');
    const [loading, setLoading] = useState('Please wait.. gathering data');
    const [searchName, setSearchName] = useState('');
    const [searchDealerId, setDealerId] = useState('');
    const [searchDmsDealerId, setSearchDmsDealerId] = useState('');
    const [searchDmsType, setSearchDmsType] = useState('');
    const [searchHosted, setSearchHosted] = useState('');
    // const [searchDate, setSearchDate] = useState(new Intl.DateTimeFormat('en-US').format(new Date()).toString());
    const [searchDate, setSearchDate] = useState(new Intl.DateTimeFormat('en-US').format(UTCDate()).toString());
    const [orderDetail, setOrderDetail] = useState([] as any);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [showOrderDetail, setShowOrderDetail] = React.useState(false);
    const [currentRow, setCurrentRow] = React.useState([] as any);
    const [formLoaded, setFormLoaded] = React.useState(false);
    const [cloneOrder, setCloneOrder] = React.useState(false);
    const [cloneOrderText, setCloneOrderText] = React.useState('');


    function UTCDate() {
        var date = new Date();
        //alert(date.getUTCDate());
        // var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(),
        //     date.getUTCDate(), date.getUTCHours(),
        //     date.getUTCMinutes(), date.getUTCSeconds());

        var newDate = new Date(date.getUTCFullYear(), date.getUTCMonth(),
            date.getUTCDate(), date.getUTCHours(),
            date.getUTCMinutes(), date.getUTCSeconds());
        //alert(newDate);

        return newDate;

    }

    function CloneOrder(value: any){
        setCloneOrder(value);
    }
    function CloneNow(){
        // const obj1 = JSON.parse(cloneOrderText);
        let url = 'https://csidealerProd.azurewebsites.net/api/Query';
        try {
            axios.post(url, {
                    "query": "SetCloneOrder",
                    "queryBody": { "dmsDealerId": search, "OrderData":cloneOrderText }}, {
                        auth: {
                            username: 'TargetMobile',
                            password: 'B6lmeZ7bK1tV'
                        }
          }).then(function(response) {
            SyncNowInstant();
            GetData2();
            alert('done');
    
          }).catch(function(error) {
                alert(error);
          });            
        }
        catch (err) {
            alert(err);
        }
    }

    function SyncNowInstant(){
        // // axios.get(`https://azurefunctionkg.azurewebsites.net/api/QueueDealerRequestOther/v2/999010/dmsDealerId=999010;dealerid=16313;env=Prod;querytype=ImportEverestOrder;text=ImportEverestOrder?code=9e7e0AOUnSE/s1UxPxyOCZHN0nrOh81eZAOdvEBvsCf9bj1efIldMQ==&clientId=default`)
        // axios.get(`https://azurefunctionkg.azurewebsites.net/api/QueueDealerRequestOther/v2/${search}/dmsDealerId=999010;dealerid=16313;env=Prod;querytype=ImportEverestOrder;text=ImportEverestOrder?code=9e7e0AOUnSE/s1UxPxyOCZHN0nrOh81eZAOdvEBvsCf9bj1efIldMQ==&clientId=default`)
        // .then(res => {
        // //   const persons = res.data;
        // //   this.setState({ persons });
        // })

    }
    function GetData() {

    }


    function GetData2() {
        try {
            // alert(search);
            if (search == '**********') return;
            //return data.filter(filterRow);
            let obj: any = new Object();
            obj.orderBy = orderBy;
            obj.order = order;
            obj.page = page;
            obj.search = search;
            //
            if (obj.search == null) obj.search = '';
            //alert(obj.search);
            if (obj.search == '') obj.search = '-9876543210';
            if (obj.search == '**********.') DefaultSearch("**********");

            //alert(obj.search.length);
            //alert(obj.search);

            // obj.searchName = searchName;
            // obj.searchDealerId = searchDealerId;
            // obj.searchDmsDealerId = searchDmsDealerId;
            // obj.rowsPerPage = rowsPerPage;
            // obj.searchDmsType = searchDmsType;
            // obj.searchDate = searchDate;
            // obj.searchHosted = searchHosted;


            let jsonString = JSON.stringify(obj);
            //let url = "http://localhost:7071/api/Query/GetExternalOrders";
            let url = 'https://azurefunctionkg.azurewebsites.net/api/query/GetExternalOrders?code=8e7e0AOUnSE/s1UxPxyOCZHN0nrOh81eZAOdvEBvsCf9bj1efIldMQ==';
            //alert(url);
            //alert(jsonString);
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: jsonString
            };
            //SetData([]);
            fetch(url, requestOptions)
                .then(response => response.json())
                .then(res =>
                (
                    SetRowsCount(res.count),
                    SetData(res.data),
                    SetDataResponse(res),
                    setLoading('')
                )
                ).catch(error => alert('Error1: ' + error));
        }
        catch (err: any) {
            alert('error1');
            alert(err.message);
            //document.getElementById("demo").innerHTML = err.message;
        }
    }

    function filterRow(element: any, index: any, array: any) {
        if (data.length > 0) {
            var obj1 = data[0];
            var keys = Object.keys(obj1);
            let i = 0;
            for (i = 0; i < keys.length; i++) {
                let cellValue = String(element[keys[i]]);
                if (cellValue.toLowerCase().includes(searchdata.toLowerCase())) { return true; }
            }
        }
        return false;

        // if (myName === '') { return true };
        // let name: string = element['name'];
        // let address: string = element['address'];
        // if (name.toLowerCase().includes(myName.toLowerCase())) { return true; }
        // if (address.toLowerCase().includes(myName.toLowerCase())) { return true; }
        // return false;
    }



    useEffect(() => {
        // alert('useEffect');
        if (formLoaded) GetData2();
    }, [formLoaded]);

    useEffect(() => {
        //alert(search);
        if (!formLoaded) {
            setFormLoaded(true);
            // let defaultSearch = localStorage.getItem('defaultSearchExternalOrder');
            // if (defaultSearch != null && defaultSearch != '') DefaultSearch(defaultSearch);
            return;
        }
        // alert(search);
        GetData2();
        // localStorage.setItem('defaultSearchExternalOrder', search);
    }, [orderBy, order, page, rowsPerPage, searchName, searchDealerId, searchDmsDealerId, searchDmsType, searchDate, searchHosted, search]);


    const handleRequestSort = (event: any, property: any) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event: any) => {
        // if (event.target.checked) {
        //     alert('handleSelectAllClick');
        //     const newSelecteds = data.map((n:any) => n.name);
        //     setSelected(newSelecteds);
        //     return;
        // }
        // setSelected([]);
    };

    const handleClick = (event: any, name: any) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected: any = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    const handleChangePage = (event: any, newPage: any) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeDense = (event: any) => {
        setDense(event.target.checked);
    };

    const isSelected = (name: any) => selected.indexOf(name) !== -1;

    // const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);
    //const emptyRows = rowsPerPage - Math.min(rowsPerPage, rowsCount  - page * rowsPerPage);
    const emptyRows = 0;

    function FormatDate(checkDate: any) {
        var parsedDate = Date.parse(checkDate)
        if (isNaN(checkDate) && !isNaN(parsedDate)) {
            let xdate = new Intl.DateTimeFormat('en-US').format(new Date(checkDate));
            return xdate;
        }
        return "";
    }

    function ViewOrderDetail(e: any, orderDetail: string) {
        const obj = JSON.parse(orderDetail);
        setOrderDetail(obj);
        // setAnchorEl(null);
        setShowOrderDetail(true);
        setAnchorEl(e.currentTarget);
        CloneOrder(false);
        //JSON.stringify(orderDetail)
        // let jsonData=JSON.stringify(orderDetail);
        // alert(jsonData);
         //const obj1 = JSON.parse(orderDetail);
        // alert(obj1);
        // alert(JSON.stringify(obj1));
        // console.log('obj1');
        // console.log(obj1);
        // setCloneOrderText(JSON.stringify(orderDetail));
        setCloneOrderText(orderDetail);
    }

    function isFeeding(checkDate: any) {
        var parsedDate = Date.parse(checkDate)
        // console.log('date-0');
        if (isNaN(checkDate) && !isNaN(parsedDate)) {
            // console.log('date-0.1');
            var date = new Date();
            date.setDate(date.getDate() - 7);
            // console.log('date');
            // console.log(date);
            // console.log(checkDate);
            if (new Date(checkDate) > date) return 1;
            return 0;
        }
        return 0;

    }

    const handleCloseOrderDetail = () => {
        setAnchorEl(null);
        setShowOrderDetail(false);
    };


    return (

        <div className={classes.root}>
            <div style={loading == '' ? { display: "none" } : {}}><h1>{loading}</h1></div>

            {/* <div style={{ position: "fixed", right: "15px", top: "15px" }} className={classes.search}>
                <div className={classes.searchIcon}>
                    <SearchIcon />
                </div>
                <InputBase
                    placeholder="Search…"
                    classes={{
                        root: classes.inputRoot,
                        input: classes.inputInput,
                    }}
                    inputProps={{ 'aria-label': 'search' }}
                    onChange={(e) => SetSearchdata(e.target.value)}
                />
            </div> */}

            {/* <input className="SearchTextBox"  placeholder="search" onChange={(e)=>SetSearchdata(e.target.value)} ></input> */}
            {/* {searchdata} */}
            {/* <Paper xclassName={classes.paper} xstyle={{ width:1175, marginTop:10  }}></Paper> */}
            <Box>
                <Paper style={{ display: loading == '' ? "table" : "none", marginTop: "10px", marginLeft: "10px" }}>


                    <EnhancedTableToolbar numSelected={selected.length} />
                    <TableContainer>
                        <Table
                            className={'myTable2 ' + classes.table}
                            aria-labelledby="tableTitle"
                            size={dense ? 'small' : 'medium'}
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead
                                classes={classes}
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={rowsCount}
                            />
                            <TableBody>
                                {/* <TableRow>
                                    <TableCell style={{ textAlign: "right" }}><input style={{ width: "60px", textAlign: "right" }} type="text" value={searchDealerId} onChange={(e: any) => { setDealerId(e.target.value) }} /> </TableCell>
                                    <TableCell style={{ textAlign: "right" }}><input style={{ width: "75px", textAlign: "right" }} type="text" value={searchDmsDealerId} onChange={(e: any) => { setSearchDmsDealerId(e.target.value) }} /> </TableCell>
                                    <TableCell><input style={{ width: "200px" }} type="text" value={searchName} onChange={(e: any) => { setSearchName(e.target.value) }} /> </TableCell>
                                    <TableCell><input style={{ width: "75px" }} type="text" value={searchDmsType} onChange={(e: any) => { setSearchDmsType(e.target.value) }} /> </TableCell>
                                    <TableCell><input style={{ width: "50px" }} type="text" value={searchHosted} onChange={(e: any) => { setSearchHosted(e.target.value) }} /> </TableCell>
                                    <TableCell colSpan={6}  >
                                        <div style={{ border: "1px solid silver", padding: "2px" }}>
                                            <input style={{ width: "80px" }} type="text" placeholder='Last updated.. ' value={searchDate} onChange={(e: any) => { setSearchDate(e.target.value) }} />

                                        </div>
                                    </TableCell>
                                </TableRow> */}

                                {

                                    data.map((row: any, index: any) => {
                                        let feedingInvoice = isFeeding(row.invoice);
                                        return (
                                            <TableRow
                                                hover
                                                onClick={(event) => setCurrentRow(row)}
                                                role="checkbox"
                                                // aria-checked={isItemSelected}
                                                // tabIndex={-1}
                                                // key={row.name}
                                                // selected={isItemSelected}
                                                selected={row.orderId == currentRow.orderId}


                                            >
                                                {/* <TableCell style={{ textAlign: "right" }} >{row.dealerId}</TableCell>
                                                <TableCell style={{ textAlign: "right" }} >{row.dmsDealerId}</TableCell> */}
                                                <TableCell style={{ textAlign: "right" }}>{row.dmsDealerId}</TableCell>
                                                <TableCell>{row.name}</TableCell>
                                                <TableCell>{row.dmsName}</TableCell>
                                                <TableCell style={{ textAlign: "right" }}>{row.orderId}</TableCell>
                                                <TableCell>{row.orderDate}</TableCell>
                                                <TableCell style={{ textAlign: "right" }}>{row.dmsOrderId}</TableCell>
                                                <TableCell style={{ textAlign: "right" }}>{row.invoiceNumber>0?row.invoiceNumber:""}</TableCell>
                                                <TableCell>{row.dmsOrderDate}</TableCell>
                                                <TableCell>{row.dmsError}</TableCell>
                                                <TableCell >{row.syncNow==true?"True":"False" }</TableCell>
                                                <TableCell>{row.isActive==true?"True":"False"}</TableCell>
                                                {/* <TableCell><a onClick={ViewOrderDetail(row.orderDetail)} > <VisibilityIcon fontSize='small'/></a></TableCell> */}
                                                <TableCell><a onClick={(event) => { ViewOrderDetail(event, row.orderDetail) }} > <VisibilityIcon fontSize='small' /></a></TableCell>

                                                {/* <TableCell>{row.dmsName}</TableCell>
                                                <TableCell>{row.isHosted ? "True" : "False"}</TableCell>
                                                <TableCell className={isFeeding(row.invoice) ? "" : classes.notFeeding} >{FormatDate(row.invoice)}</TableCell>
                                                <TableCell className={isFeeding(row.customer) ? "" : classes.notFeeding}>{FormatDate(row.customer)}</TableCell>
                                                <TableCell className={isFeeding(row.inventoryPart) ? "" : classes.notFeeding}>{FormatDate(row.inventoryPart)}</TableCell>
                                                <TableCell className={isFeeding(row.inventoryWG) ? "" : classes.notFeeding}>{FormatDate(row.inventoryWG)}</TableCell>
                                                <TableCell>{FormatDate(row.user)}</TableCell>
                                                <TableCell className={isFeeding(row.dealer) ? "" : classes.notFeeding}>{FormatDate(row.dealer)}</TableCell> */}
                                            </TableRow>
                                        );
                                    })}
                                {emptyRows > 0 && (
                                    <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <table>
                        <tr >
                            <td style={{ paddingLeft: "10px" }}>
                                External&nbsp;Orders
                            </td>
                            <td style={{ width: "100%" }}>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 15, 20, 25]}
                                    component="div"
                                    count={rowsCount}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}
                                />

                            </td>
                        </tr>
                    </table>
                    {/* <TablePagination
                        rowsPerPageOptions={[15, 20, 25, 30]}
                        component="div"
                        count={rowsCount}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                    /> */}
                </Paper>
                {/* <div style={loading != '' ? { display: "none" } : { marginLeft: "10px", marginTop: "5px", color: "gray", fontSize: "small" }}>
                    Summary data as of {dataResponse.lastUpdate}
                </div> */}

                {/* <Pretty>{orderDetail}</Pretty> */}


            </Box>

            <Popover
                open={showOrderDetail}
                anchorEl={anchorEl}
                onClose={handleCloseOrderDetail}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <Box>
                    <div style={{ backgroundColor: "#EAEDED", padding: "2px 4px" }} >OrderId: {currentRow.orderId}</div>
                    <div style={{ padding: "5px 10px" }}>
                        <pre>{JSON.stringify(orderDetail, null, 2)}</pre>
                        {(search == '999007' || search == '999010') && (
                            <div>
                                <Button variant="contained" onClick={CloneOrder} >Clone this order</Button>
                                {cloneOrder && (
                                    <Box style={{minWidth:"300px"}}>
                                        <TextField multiline fullWidth label="Json Data" style={{ fontSize: "small" }} value={cloneOrderText} onChange={(e) => setCloneOrderText(e.target.value)} />
                                        <Button variant="contained" onClick={() => CloneNow()}>Clone now</Button>
                                    </Box>

                                )}
                                {/* <textarea value={JSON.stringify(orderDetail)}></textarea> */}

                            </div>
                        )
                        }
                    </div>
                </Box>
            </Popover>

            {/* <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      /> */}
        </div>
    );
}
